import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParkAndRideFacility = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "a",
			height: 9,
			maskUnits: "userSpaceOnUse",
			width: 6,
			x: 23,
			y: 15,
			children: /* @__PURE__ */ _jsx("path", {
				d: "m24 16 4 7",
				fill: "none",
				stroke: "#fff",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m0 0h32v32h-32z",
			fill: "#0f3993"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m4 15.99h2.66c.95 0 1.69-.22 2.21-.65s.78-1.06.78-1.88-.26-1.41-.77-1.83c-.52-.42-1.25-.63-2.22-.63h-2.66v10",
			stroke: "#fff",
			strokeLinecap: "square",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#a)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "m0 0h8v6h-8z",
				fill: "#fff",
				transform: "matrix(1 0 0 -1 22 22)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#fff",
			strokeLinecap: "square",
			strokeWidth: 2,
			children: [
				/* @__PURE__ */ _jsx("path", { d: "m21.5498 15.99h2.75c.95 0 1.69-.22 2.2-.65.52-.43.77-1.06.77-1.88s-.26-1.41-.77-1.83-1.25-.63-2.2-.63h-2.75v10" }),
				/* @__PURE__ */ _jsx("path", { d: "m12.3301 16.39h5.81" }),
				/* @__PURE__ */ _jsx("path", { d: "m15.23 19.29v-5.81" })
			]
		})
	]
});
export default SvgParkAndRideFacility;
